import useSWR, { type SWRConfiguration } from "swr";
import { apiClient } from "@/lib/api/client";
import { apiPaths } from "@/lib/api/paths";
import type { Sample } from "@typings/entities/samples";

async function getSampleById(id: string): Promise<Sample> {
  const response = await apiClient.get<Sample>(apiPaths.samples.getById(id));
  return response.data;
}

export function useGetSampleById(
  sampleId: string | null,
  options?: SWRConfiguration,
) {
  return useSWR(
    sampleId ? [`fetch-sample-${sampleId}`] : null,
    () => getSampleById(sampleId!),
    options,
  );
}
